import {
    InputBase,
    MenuItem,
    Select,
    ToggleButton,
    Tooltip,
} from '@mui/material';

import { ReactEditor, useSlate } from 'slate-react';
import useSelectedBlock from '../hooks/useSelectedBlock';
import { useTranslation } from 'react-i18next';

function SelectHeading() {
    const { t } = useTranslation();
    const editor = useSlate();
    const { type, setType } = useSelectedBlock();

    const headings = [
        { label: t('Paragraph'), value: 'paragraph' },
        { label: t('Heading') + ' 1', value: 'heading-one' },
        { label: t('Heading') + ' 2', value: 'heading-two' },
        { label: t('Heading') + ' 3', value: 'heading-three' },
        { label: t('Heading') + ' 4', value: 'heading-four' },
    ];

    const value =
        headings.find(heading => heading.value === type)?.value || 'paragraph';

    return (
        <Tooltip title={t('Heading')} placement="top">
            <Select
                value={value}
                onChange={e => setType(e.target.value)}
                input={<InputBase />}
                onClose={() => ReactEditor.focus(editor)}
                sx={{
                    width: 112,
                    // minWidth: 96,
                    // justifyContent: 'space-between',
                    height: 28,
                }}
                slots={{
                    root: ToggleButton,
                }}
                slotProps={{
                    root: {
                        value: false,
                    },
                }}
            >
                {headings.map(heading => (
                    <MenuItem key={heading.value} value={heading.value}>
                        {heading.label}
                    </MenuItem>
                ))}
            </Select>
        </Tooltip>
    );
}

export default SelectHeading;
